/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminPalletOrderAttachmentType = {
    PalletOrderAttachmentTypeAmazonManifest: 'amazonManifest'
} as const;
export type AdminPalletOrderAttachmentType = typeof AdminPalletOrderAttachmentType[keyof typeof AdminPalletOrderAttachmentType];


export function instanceOfAdminPalletOrderAttachmentType(value: any): boolean {
    for (const key in AdminPalletOrderAttachmentType) {
        if (Object.prototype.hasOwnProperty.call(AdminPalletOrderAttachmentType, key)) {
            if (AdminPalletOrderAttachmentType[key as keyof typeof AdminPalletOrderAttachmentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminPalletOrderAttachmentTypeFromJSON(json: any): AdminPalletOrderAttachmentType {
    return AdminPalletOrderAttachmentTypeFromJSONTyped(json, false);
}

export function AdminPalletOrderAttachmentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPalletOrderAttachmentType {
    return json as AdminPalletOrderAttachmentType;
}

export function AdminPalletOrderAttachmentTypeToJSON(value?: AdminPalletOrderAttachmentType | null): any {
    return value as any;
}

export function AdminPalletOrderAttachmentTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminPalletOrderAttachmentType {
    return value as AdminPalletOrderAttachmentType;
}

